"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageLevelError_1 = require("./PageLevelError");
exports.default = PageLevelError_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelError/index.js
// module id = 1714
// module chunks = 8